module.exports = __webpack_public_path__ + "img/arrow_right.d9c12325.svg";